var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4167 17.4303H16.6667V8.03261L9.375 2.36131L2.08333 8.03261V17.4303H8.33333V11.1803H10.4167V17.4303ZM18.75 18.472C18.75 19.0473 18.2836 19.5136 17.7083 19.5136H1.04167C0.466375 19.5136 0 19.0473 0 18.472V7.52314C0 7.20169 0.148406 6.89826 0.402146 6.7009L8.73552 0.219422C9.11167 -0.0731406 9.63833 -0.0731406 10.0145 0.219422L18.3478 6.7009C18.6016 6.89826 18.75 7.20169 18.75 7.52314V18.472Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.005a3f7338f0eae652fef2c809ee6c12.svg";
export { ForwardRef as ReactComponent };